'use client';

import { createContext } from 'react';

import type { DropdownRootContextInterface } from '../types/dropdown-root.types';

export const DropdownRootContext = createContext({} as DropdownRootContextInterface);

DropdownRootContext.displayName = 'Dropdown.Root.Context';
